// assets
import { FileTextOutlined } from '@ant-design/icons';

// icons
const icons = {
  FileTextOutlined
};

const opexVendor = {
  id: 'opex-vendor',
  title: '',
  type: 'group',
  roles: ['opex_vendor'], // Only OPEX vendors can see this group
  children: [
    {
      id: 'opex-invoices',
      title: 'My Invoices',
      type: 'item',
      url: 'opex-vendor/invoices',
      icon: icons.FileTextOutlined
    }
  ]
};

export default opexVendor;
